<script lang="ts">
  import AuthedUserTopBarPage from '../../Navigation/TopLevelPages/AuthedUserTopBarPage.svelte'
  import ReviewGrid from '../../Review/Grid.svelte'
  import { any_results } from '../../Review/Results'
</script>

<AuthedUserTopBarPage>
  {#if $any_results}
    <ReviewGrid />
  {:else}
    <p>Come review your team's results here when you've had your first Retro!</p>
  {/if}
</AuthedUserTopBarPage>
